import { useEffect } from 'react';
import { matchPath } from 'react-router-dom';

// ==============================|| MENU COLLAPSED - RECURSIVE FUNCTION ||============================== //

function setParentOpenedMenu(items, pathname, menuId, setSelected, setOpen) {
  for (const item of items) {
    // Recursively check child menus
    if (item.children?.length) {
      setParentOpenedMenu(item.children, pathname, menuId, setSelected, setOpen);
    }

    const itemPath = item.link || item.url;

    // Check if the current menu item matches the pathname (prefix match)
    if (itemPath && matchPath({ path: itemPath, end: false }, pathname)) {
      setSelected(menuId ?? null); // Select the parent menu
      setOpen(true);               // Open the menu
      return;                      // We can stop once a match is found
    }
  }
}

// ==============================|| MENU COLLAPSED - HOOK ||============================== //

export default function useMenuCollapse(menu, pathname, miniMenuOpened, setSelected, setOpen, setAnchorEl) {
  useEffect(() => {
    // Close the menu initially
    setOpen(false);

    // Reset selection based on menu state
    if (!miniMenuOpened) {
      setSelected(null);
    } else {
      setAnchorEl(null);
    }

    // If menu has children, determine which should be opened
    if (menu.children?.length) {
      setParentOpenedMenu(menu.children, pathname, menu.id, setSelected, setOpen);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, menu.children]);
}